import { Component, Input } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { ObservationDetailsModule } from './observation-details.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-observation-details-modal',
    standalone: true,
    imports: [
        NgSelectModule,
        TranslateModule,
        ObservationDetailsModule
    ],
    templateUrl: './observation-details-modal.component.html',
    styleUrl: './observation-details-modal.component.scss'
})
export class ObservationDetailsModalComponent {

    constructor(private activeModal: NgbActiveModal) {
    }

    @Input() observationUnitId: string;
    @Input() studyId: number;
    @Input() datasetId: number;


    cancel() {
        this.activeModal.dismiss();
    }

}
